<template>
  <div class="main">
    <!-- 内容区 -->
    <div class="content_wrap">
      <!-- 上面返回个人主页按钮 -->
      <div class="top_btn">
        <button @click="backUser">返回个人主页</button>
      </div>
      <!-- 下面大盒子区域 -->
      <div class="content_box">
        <div class="user_icon">
          <img :src="header" alt="" />
          <p class="nick_name">{{ nick_name }}</p>
        </div>
        <div class="info-content">
          <h3>基本信息</h3>
          <p>
            <span>昵称：</span><em>{{ nick_name }}</em>
          </p>
          <p>
            <span>手机号：</span>
            <em>{{
              phone ? phone.replace(reg, "$1****$2") : "暂未绑定手机号"
            }}</em>
            <!-- <i @click="update('sendCode')" v-if="phone">修改</i
            ><i @click="bindInfo('sendCode')" v-else>绑定</i> -->
          </p>
          <p>
            <span>邮箱：</span>
            <em>{{
              email ? email.replace(reg1, "$1****$2") : "暂未绑定邮箱"
            }}</em>

            <!-- <i @click="update('sendEmailCode')" v-if="email">修改</i
            ><i @click="bindInfo('sendEmailCode')" v-else>绑定</i> -->
          </p>
          <p>
            <span>密码：</span>
            <em>******</em>
            <i @click="updatePass">修改</i>
          </p>
        </div>
      </div>
    </div>

    <!-- 弹窗部分 -->
    <div v-if="is_show_popup" class="info_edit">
      <p class="edit_text" v-text="edit_text"></p>
      <span @click="closePopup" class="close_popup"></span>
      <div class="popup_content">
        <p v-if="is_check" class="tips_text1">
          为了保障您的账号安全，变更信息前需验证身份
        </p>
        <p v-if="!is_check && is_phone" class="tips_text2">
          已完成验证，请输入新手机号码
        </p>
        <p v-if="!is_check && !is_phone" class="tips_text2">
          已完成验证，请输入新邮箱
        </p>
        <p class="type_text">验证方式</p>
        <el-form ref="info" :model="info" :rules="rules">
          <el-form-item v-if="is_check">
            <div class="icon_img">
              <img :src="img.phone" alt="" />
            </div>

            <!-- 验证时显示下拉选择 -->
            <el-select v-model="api">
              <el-option
                v-for="item in list"
                :key="item.value"
                :value="item.value"
                :label="item.name"
              >
                {{ item.name }}
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="!is_check && is_phone">
            <el-form-item
              class="phone_input"
              :rules="[
                { required: true, validator: validatePhone, trigger: 'blur' },
              ]"
              prop="phone"
            >
              <div class="icon_img">
                <img :src="img.phone" alt="" />
              </div>
              <el-input
                v-model="info.phone"
                placeholder="请输入您的手机号"
              ></el-input>
            </el-form-item>
          </div>
          <div v-if="!is_check && !is_phone">
            <el-form-item
              class="phone_input"
              v-if="!is_check && !is_phone"
              :rules="[
                { required: true, validator: validateEmail, trigger: 'blur' },
              ]"
              prop="email"
            >
              <div class="icon_img">
                <img :src="img.phone" alt="" />
              </div>
              <el-input
                v-model="info.email"
                placeholder="请输入您的邮箱"
              ></el-input>
            </el-form-item>
          </div>

          <el-form-item
            :rules="[
              { required: true, message: '请输入验证码', trigger: 'blur' },
            ]"
            class="sms_code"
            prop="verify_code"
          >
            <div class="icon_img">
              <img :src="img.code" alt="" />
            </div>
            <el-input v-model="info.verify_code" placeholder="验证码">
            </el-input>
            <el-button
              class="code_btn"
              type="primary"
              :disabled="!isGetCode"
              long
              @click="getCodeBtn"
              v-text="code_text"
            ></el-button>
          </el-form-item>

          <el-form-item class="item_button btn-content">
            <el-button
              v-if="is_check"
              class="bind_btn"
              @click="next"
              type="primary"
              :disabled="is_disable"
              long
              >下一步</el-button
            >
            <el-button
              v-else
              class="bind_btn"
              @click="sure"
              type="primary"
              :disabled="is_disable"
              long
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="is_show_popup" class="mask"></div>
  </div>
</template>

<script>
import { Message } from "element-ui";

export default {
  data() {
    return {
      is_show_popup: false,
      nick_name:
        (localStorage.userInfo && JSON.parse(localStorage.userInfo).name) || "",
      user_name:
        (localStorage.userInfo && JSON.parse(localStorage.userInfo).rname) ||
        "",
      phone:
        (localStorage.userInfo && JSON.parse(localStorage.userInfo).phone) ||
        "",
      email:
        (localStorage.userInfo && JSON.parse(localStorage.userInfo).email) ||
        "",
      header:
        (localStorage.userInfo && JSON.parse(localStorage.userInfo).header) ||
        this.img.header1,
      reg: /^(\d{3})\d{4}(\d{4})$/,
      reg1: /(.{1}).+(.{2}@.+)/g,
      edit_text: "修改手机号",
      list: [],
      api: "", //选择邮箱、手机号时对应的接口地址
      is_disable: false, //点击确定，下一个时是否可点
      isGetCode: true,
      code_text: "获取验证码",
      codeTimer: 60,
      is_check: true, //是下一步还是确定
      info: {
        verify_code: "",
        phone: "",
        email: "",
      },
      rules: {
        // verify_code: [ { required: true, message: "请输入验证码", trigger: "blur" }],
        // phone: [{required: true,validator: validatePhone,trigger: "blur"}],
        // email: [{required: true,validator: validateEmail,trigger: "blur"}],
      },
      inner: null,
      is_phone: true,
    };
  },
  methods: {
    updatePass() {
      this.$store.commit("changePass", true);
      this.$store.commit("forgetOrUpdate", false);
    },
    // 校验手机号
    validatePhone(rule, value, callback) {
      if (!this.info.phone) {
        callback(new Error("手机号不能为空"));
      } else if (!/^1[345789]\d{9}$/.test(this.info.phone)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    },
    validateEmail(rule, value, callback) {
      if (!this.info.email) {
        callback(new Error("邮箱不能为空"));
      } else if (
        !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.info.email)
      ) {
        callback(new Error("邮箱格式不正确"));
      } else {
        callback();
      }
    },
    // 点击修改手机号或者修改邮箱
    update(val) {
      this.api = val; //点的是邮箱还是手机号，验证方式优先显示哪个；
      if (this.api == "sendCode") {
        this.edit_text = "修改手机号";
        this.is_phone = true;
      } else {
        this.edit_text = "修改邮箱";
        this.is_phone = false;
      }
      this.is_show_popup = true;
    },
    // 点击绑定手机号或者邮箱
    bindInfo(val) {
      //点的是邮箱还是手机号，验证方式优先显示哪个；
      if (val == "sendCode") {
        this.api = "sendEmailCode";
        this.edit_text = "绑定手机号";
        this.is_phone = true;
      } else {
        this.api = "sendCode";
        this.edit_text = "绑定邮箱";
        this.is_phone = false;
      }
      this.is_show_popup = true;
    },
    closePopup() {
      // 关闭弹窗
      if (this.$refs.info) {
        this.$refs.info.resetFields();
      }
      if (this.inner) {
        window.clearTimeout(this.inner);
      }
      this.is_show_popup = false;
      this.isGetCode = true;
      this.code_text = "获取验证码";
      this.odeTimer = 60;
      this.is_check = true; //是下一步还是确定
    },
    next() {
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.is_disable = true;
          let obj = {};
          if (this.api == "sendEmailCode") {
            // 说明是邮箱
            obj = {
              codebox: this.email,
              verify_code: this.info.verify_code,
            };
          } else {
            obj = {
              codebox: this.phone,
              verify_code: this.info.verify_code,
            };
          }
          this.$store
            .dispatch("post", { url: "check_verifycode", data: obj })
            .then((res) => {
              this.is_disable = false;
              if (res) {
                this.is_check = false;
                this.codeTimer = 60;
                this.code_text = "获取验证码";
                this.isGetCode = true;
                this.$refs.info.resetFields();
                if (this.inner) {
                  window.clearTimeout(this.inner);
                }
              }
            });
        }
      });
    },
    sure() {
      this.$refs.info.validate((valid) => {
        if (valid) {
          let type, phone;
          if (this.is_phone) {
            type = 1;
            phone = this.info.phone;
          } else {
            type = 2;
            phone = this.info.email;
          }
          let data = {
            type: type,
            textinfo: phone,
            code: this.info.verify_code,
          };
          this.$store
            .dispatch("post", { url: "updateInfo", data: data })
            .then((res) => {
              if (res) {
                localStorage.userInfo = JSON.stringify(res.data);
                Message({
                  message: "修改成功",
                  type: "success",
                  showClose: false,
                  duration: 500,
                  onClose: () => {
                    location.reload();
                  },
                });
              }
            });
        }
      });
    },
    //验证码登录时获取验证码
    getCodeBtn() {
      if (this.is_check) {
        // 说明是在验证的时候
        let obj = {};
        if (this.api == "sendEmailCode") {
          // 说明是邮箱,直接用本地存的邮箱号码就行，同理用的是本地存的手机号
          obj = {
            email: this.email,
          };
        } else {
          obj = {
            phone: this.phone,
          };
        }
        if (this.isGetCode) {
          this.$store
            .dispatch("post", { url: this.api, data: obj })
            .then((res) => {
              if (res) {
                this.isGetCode = false;
                this.timer();
                Message.success(res.msg);
              }
            });
        }
      } else {
        // 说明已经验证结束，要输入新的邮箱或者手机号了
        // 这个时候发送验证码，需要验证一下输入的邮箱或者手机号是否正确
        if (this.is_phone) {
          if (!/^1[345789]\d{9}$/.test(this.info.phone)) {
            Message.warning("手机号格式不正确");
            return false;
          } else {
            let obj = { phone: this.info.phone };
            if (this.isGetCode) {
              this.$store
                .dispatch("post", { url: "sendCode", data: obj })
                .then((res) => {
                  if (res) {
                    this.isGetCode = false;
                    this.timer();
                    Message.success(res.msg);
                  }
                });
            }
          }
        } else {
          // 说明是邮箱
          if (
            !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.info.email)
          ) {
            Message.warning("邮箱格式不正确");
            return false;
          } else {
            let obj = { email: this.info.email };
            if (this.isGetCode) {
              this.$store
                .dispatch("post", { url: "sendEmailCode", data: obj })
                .then((res) => {
                  if (res) {
                    this.isGetCode = false;
                    this.timer();
                    Message.success(res.msg);
                  }
                });
            }
          }
        }
      }
    },
    // 短信验证码定时器
    timer() {
      var _this = this;
      if (_this.codeTimer === 1) {
        _this.code_text = "获取验证码";
        _this.isGetCode = true;
        _this.codeTimer = 60;
      } else {
        _this.codeTimer = _this.codeTimer - 1;
        _this.code_text = _this.codeTimer + "s";
        this.inner = setTimeout(function () {
          _this.timer();
        }, 1000);
      }
    },
    backUser() {
      this.$store.commit("changePath", { path: "user" });
    },
    save() {
      if (!this.nick_name.trim()) {
        Message.warning("请输入昵称！");
        return false;
      } else if (!this.user_name.trim()) {
        Message.warning("请输入真实姓名！");
        return false;
      } else {
        let data = {
          name: this.nick_name.trim(),
          rname: this.user_name.trim(),
        };
        this.$store
          .dispatch("post", { url: "edit", data: data })
          .then((res) => {
            if (res) {
              Message.success(res.msg);
              localStorage.userInfo = JSON.stringify(res.data);
            }
          });
      }
    },
  },
  mounted() {
    if (!this.isLogin()) {
      Message.warning("尚未登录，请您先登录");
      let _this = this;
      setTimeout(function () {
        _this.$store.commit("changePath", { path: "video" });
      }, 1000);
    } else {
      if (this.phone) {
        this.list.push({
          name: this.phone.replace(this.reg, "$1****$2"),
          value: "sendCode",
          number: this.phone,
        });
      }
      if (this.email) {
        this.list.push({
          name: this.email.replace(this.reg1, "$1****$2"),
          value: "sendEmailCode",
          number: this.email,
        });
      }
      this.api = this.list[0].value;
    }
  },
};
</script>
<style >
.close_popup {
  position: absolute;
  color: #333333;
  top: 23px;
  right: 27px;
  width: 18px;
  height: 18px;
  display: inline-block;
  cursor: pointer;
  background: url(./../../assets/img/qrcode/black_close.png) no-repeat 0 0 /
    100% 100%;
}
</style>
<style lang="less">
.el-form-item__content::after,
.el-form-item__content::before {
  content: none;
}
.phone_input {
  .el-input__inner {
    background: #f2f2f2;
    border: none;
    border-radius: 4px;
    width: 281px;
    padding-left: 36px;
    height: 32px;
    line-height: 32px;
  }
}
.el-select-dropdown__item {
  font-size: 12px;
}
.info_edit {
  .el-form {
    .btn-content {
      margin-bottom: 16px;
      text-align: center;
      margin-top: 24px;
      button {
        height: 32px;
        line-height: 32px;
        width: 200px;
        text-align: center;
        margin: 0 auto;
        padding: 0;
        border: none;
        background: #1f86f8;
      }
    }
  }
}
.info .el-input {
  width: 330px;
}
.info .el-input .el-input__inner {
  width: 330px;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #666666;
  color: #202020;
  font-size: 16px;
  padding: 0 20px;
}
.info .el-input .el-input__inner::placeholder {
  color: #202020;
}
.el-form-item {
  margin-bottom: 16px;
  height: 32px;
  line-height: 32px;
  .password_img {
    width: 26px;
    text-align: center;
    position: absolute;
    right: 9px;
    top: 0;
    z-index: 100;
    img {
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .icon_img {
    width: 18px;
    text-align: center;
    position: absolute;
    left: 9px;
    z-index: 100;
    img {
      vertical-align: middle;
    }
  }
  .el-form-item__content {
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    border-radius: 4px;

    .el-select {
      width: 100%;
      .el-input__icon {
        line-height: 32px;
        height: 32px;
      }
      .el-input__inner {
        height: 32px;
        line-height: 32px;
        background: #f2f2f2;
        border: none;
        border-radius: 4px;
        width: 285px;
        padding-left: 40px;
      }
    }
  }
}
.sms_code {
  .el-input {
    width: 189px;
  }
  .el-input__inner {
    background: #f2f2f2;
    border: none;
    border-radius: 4px;
    width: 189px;
    padding-left: 36px;
    height: 32px;
    line-height: 32px;
  }
  .el-button {
    width: 86px;
    text-align: center;
    line-height: 32px;
    height: 32px;
    padding: 0;
    font-size: 12px;
    color: #1f86f8;
  }
}
</style>

<style lang="less" scoped>
.mask {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.41);
  z-index: 100;
}
div.content_wrap {
  width: 1300px;
  margin: 0 auto;
  color: #202020;
  padding-bottom: 38px;
  margin-top: -5px;

  div.top_btn {
    button {
      margin-bottom: 20px;
      width: 100px;
      height: 30px;
      background: #1f86f8;
      border-radius: 12px;
      font-size: 12px;
      color: #ffffff;
      line-height: 30px;
    }
  }

  div.content_box {
    width: 1300px;
    padding-left: 30px;
    background: #ffffff;
    border-radius: 22px;
    height: 606px;
    div.user_icon {
      width: 130px;
      margin: 0 auto;
      text-align: center;
      img {
        margin-top: 40px;
        margin-bottom: 25px;
        height: 113px;
        width: 113px;
        border-radius: 50%;
      }
      .nick_name {
        text-align: center;
        font-family: "siyuan-Medium";
        font-size: 16px;
        line-height: 16px;
      }
    }
    .info-content {
      width: 545px;
      margin: 0 auto;
      h3 {
        color: #000000;
        font-size: 20px;
        line-height: 20px;
        margin-top: 20px;
        margin-bottom: 7px;
      }
      p {
        margin-top: 20px;
        font-size: 16px;
        line-height: 16px;
        color: #2a2a2a;
        span {
          display: inline-block;
          width: 100px;
          text-align: right;
          font-size: 16px;
          color: #6c6c6c;
        }
        em {
          display: inline-block;
          width: 219px;
          height: 32px;
          line-height: 32px;
          padding-left: 17px;
          background: #f2f2f2;
        }
        i {
          font-size: 16px;
          color: #ffffff;
          display: inline-block;
          background: #1783ff;
          width: 99px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-style: normal;
          margin-left: 121px;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
  }
}
.info_edit {
  cursor: pointer;
  z-index: 101;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 410px;
  height: 282px;
  padding: 24px 62px 27px 27px;
  border-radius: 22px;
  .edit_text {
    font-size: 16px;
    color: #333333;
    line-height: 16px;
  }

  .popup_content {
    padding-left: 32px;
    padding-top: 18px;
    .tips_text1 {
      color: #999999;
      font-size: 12px;
      line-height: 12px;
      margin-bottom: 20px;
    }
    .tips_text2 {
      color: #666666;
      font-size: 12px;
      line-height: 12px;
      margin-bottom: 20px;
    }
    .type_text {
      color: #333333;
      font-size: 16px;
      line-height: 16px;
      margin-bottom: 12px;
    }
  }
}
</style>